// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.attenders-section__preview .preview {\n  display: inline-block;\n  overflow: hidden;\n  width: 100%;\n  max-width: 100%;\n  text-overflow: ellipsis;\n}\n", ""]);
// Exports
module.exports = exports;
